
import { Component, Vue } from "vue-property-decorator";
import { apiProfitSharingDetail } from "@/api/order";

@Component
export default class ProfitSharingDetail extends Vue {
  loading = false;
  detail: any = {};

  async created() {
    const id = this.$route.query.id;
    if (!id) return;
    this.loading = true;
    try {
      this.detail = await apiProfitSharingDetail({ id });
    } finally {
      this.loading = false;
    }
  }
}
